//CAPTURE ORDER
export const POSTHOG_CAPTURE_ORDER_CREATED = 'order_created';
export const POSTHOG_CAPTURE_ORDER_ADD_ITEM = 'order_add_item';
export const POSTHOG_CAPTURE_ORDER_REMOVE_ITEM = 'order_remove_item';
export const POSTHOG_CAPTURE_ORDER_CHANGE_STORE = 'order_change_store';
export const POSTHOG_CAPTURE_ORDER_UPDATED = 'order_updated';
export const POSTHOG_CAPTURE_ORDER_VERIFIED = 'order_verified';
export const POSTHOG_CAPTURE_ORDER_EXPIRED = 'order_expired';
export const POSTHOG_CAPTURE_ORDER_MANUALLY_VERIFIED = 'order_manually_verified';

//ORDER STATUS
export const POSTHOG_ORDER_CREATED_STATUS = 'created';
export const POSTHOG_ORDER_VERIFIED_STATUS = 'verified';
export const POSTHOG_ORDER_EXPIRED_STATUS = 'expired';
export const POSTHOG_ORDER_MANUALLY_VERIFIED_STATUS = 'manually_verified';

//CAPTURE PAYMENT
export const POSTHOG_CAPTURE_PAYMENT_COMPLETED = 'payment_completed';

//CAPTURE USER
export const POSTHOG_CAPTURE_USER_PROFIL_CREATED = 'user_profil_created';
export const POSTHOG_CAPTURE_USER_ANONYMOUS_PROFIL_CREATED = 'anonymous_user_created';

//CAPTURE PHONE NUMBER
export const POSTHOG_CAPTURE_PHONE_SIGN_UP_SMS = 'phone_sign_up_send_sms'
export const POSTHOG_CAPTURE_PHONE_SIGN_UP_SUCCESS = 'phone_sign_up_success'
export const POSTHOG_CAPTURE_PHONE_SIGN_UP_FUNNEL_COMPLETED = 'phone_sign_up_funnel_completed'
export const POSTHOG_CAPTURE_PHONE_SIGN_IN_SMS = 'phone_sign_in'
export const POSTHOG_CAPTURE_PHONE_INVALID_NUMBER = 'phone_invalid_number'


//GROUP ORDER
export const POSTHOG_GROUP_ORDER = 'order';
